<template>
    <div
        class="title-bar"
        :style="{
            height: props.tall ? 'fit-content' : `${props.heightPx}px`,
            minHeight: props.tall ? '40px' : `${props.heightPx}px`,
            maxHeight: props.tall ? '90px' : `${props.heightPx}px`,
        }"
    >
        <slot />
    </div>
</template>

<script setup lang="ts">

const props = withDefaults(
    defineProps<{
        heightPx?: number;
        tall?: boolean;
    }>(),
    {
        heightPx: 40,
    },
);

</script>

<style lang="scss" scoped>

.title-bar {
    align-items: center;
    background: var(--neutral100);
    border-bottom: 1px solid var(--neutral300);
    font-size: var(--mediumFontSize);
    display: flex;
    gap: var(--defaultSpacing);
    padding: 0 var(--defaultSpacing);
    &.space-between {
        justify-content: space-between;
    }
    &.center {
        justify-content: center;
    }
}
</style>
